var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStarNonfilled = function SvgIconStarNonfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA0A5",
    strokeWidth: 2,
    d: "m11.593 12.21.52-.076.234-.472L16 4.26l3.653 7.403.233.47.52.077 8.165 1.188-5.909 5.756-.377.367.09.518 1.396 8.134-7.306-3.838L16 24.09l-.465.245-7.307 3.838 1.397-8.134.09-.518-.377-.367L3.43 13.39z"
  })));
};
export default SvgIconStarNonfilled;